/**
 * A foto de perfil de quem usa o sistema (061, 25/09/2026).
 *
 * Troca e tira a própria pessoa, em `/v1/me/foto`. A imagem é servida por
 * link assinado (`/v1/fotos/{token}`), que dura cinco minutos e muda quando a
 * foto muda — o `<img>` do navegador não manda `Authorization`.
 */

import { z } from 'zod';

/** O que as rotas de trocar e tirar devolvem: o link novo, ou nulo sem foto. */
export const FotoDePerfilSchema = z.object({
  foto_url: z.string().nullable(),
});

export type FotoDePerfil = z.infer<typeof FotoDePerfilSchema>;

/**
 * O corpo é `multipart/form-data` com a imagem no campo `foto` — por isso a
 * parte JSON é vazia. A tela reduz a imagem a 256×256 antes de mandar.
 */
export const EnviarFotoDePerfilSchema = z.object({}).strict();

/** Teto da imagem, igual ao CHECK da migração 061. */
export const LIMITES_DA_FOTO = { kilobytes: 512, lado: 256 } as const;
